import React, { useState, useMemo } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItemButton,
  ListItemText,
  Button,
  TextField,
  InputAdornment,
  Box
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useTranslation } from 'react-i18next';

const TemplateSelectDialog = ({ open, templates, onClose, onSelect }) => {
  const { t } = useTranslation();
  const [searchText, setSearchText] = useState('');

  // Gefilterte Templates basierend auf Suchtext
  const filteredTemplates = useMemo(() => {
    if (!searchText.trim()) {
      return templates;
    }
    
    const searchLower = searchText.toLowerCase();
    return templates.filter(template => 
      (template.name || '').toLowerCase().includes(searchLower) ||
      (template.description || '').toLowerCase().includes(searchLower)
    );
  }, [templates, searchText]);

  // Reset search when dialog opens/closes
  React.useEffect(() => {
    if (!open) {
      setSearchText('');
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{t('report.templateDialogTitle')}</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <TextField
            fullWidth
            size="small"
            placeholder={t('report.templateSearch')}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Box>
        
        {filteredTemplates.length === 0 ? (
          <p>{searchText ? t('report.noTemplatesMatchSearch') : t('report.noTemplatesFound')}</p>
        ) : (
          <List>
            {filteredTemplates.map((tpl) => (
              <ListItemButton key={tpl.id} onClick={() => onSelect(tpl)}>
                <ListItemText 
                  primary={tpl.name} 
                  secondary={`${tpl.template_type === 'S' ? t('report.structuredReport') : t('report.freetextReport')}${tpl.description ? ` - ${tpl.description}` : ''}`} 
                />
              </ListItemButton>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('common.cancel')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default TemplateSelectDialog; 